<div class="d-flex social">
  @for (social of socialMediaList; track social) {
    <a [href]="social.url" target="_blank">
      <i class="bi" [class]="social.iconClass"></i>
    </a>
  }
</div>
